<div class="main-content">
  <div class="container-fluid p-0">
    <div class="row">
      <div class="col-md-12">
        <span class="pull-left">
          <h2 class="text-purple-manax m-0 pl-3 title-section">Presupuestos</h2>
          <!--p class="text-purple-manax pl-3">Listado de Presupuestos</p-->
        </span>
        <!--span class="pull-right pt-1 pb-4 pr-3">
          <button mat-raised-button type="button" class="btn btn-manax p-2 mr-3" (click)="openNewTaskModal()">
            <i class="material-icons">add</i>&nbsp;<span class="d-none d-sm-inline">Nuevo Presupuesto</span>
          </button>
        </span-->
        <span class="pull-right pt-1 pb-4">
          <button mat-raised-button type="button" class="btn btn-manax p-2 mr-1" (click)="openNewQuotesModal()">
            <i class="material-icons">add</i>&nbsp;<span class="d-none d-sm-inline">Nuevo</span>
          </button>
        </span>

        <table class="table table-hover m-0 align-top" stickyHeader stickyFooter>

          <thead class="text-manax">
            <tr>

              <!-- All -->
              <th class="p-0 pl-2">
                <div class="form-check m-0 mx-2">
                  <label class="form-check-label">
                    <input class="form-check-input input-sm" type="checkbox" (click)="toggleSelection()"
                      [checked]="selection.all">
                    <span class="form-check-sign">
                      <span class="check"></span>
                    </span>
                  </label>
                </div>
              </th>

              <!-- PC -->
              <th class="d-none d-md-table-cell align-top" style="width: 150px;">
                Nº<br>
              </th>
              <th class="align-top" style="height: 65px; position: relative; max-width: 1000px;">
                Estado<br> <br>
                <select class="filter small" [(ngModel)]="filter.filters.status" (ngModelChange)="lazySearch()"
                  (click)="$event.stopPropagation()" width="200px"
                  style="margin-top: 10px; max-width: 1000px; position: absolute; top: 29px; left: 0px;">
                  <option [ngValue]="undefined"> Todos </option>
                  <option *ngFor="let key of quoteStatusesKeys" [ngValue]="key">{{quoteStatuses[key]}}</option>
                </select>
              </th>
              <th class="d-none d-md-table-cell align-top">
                Cliente<br>
                <input type="text" class="filter small" [(ngModel)]="filter.filters.client"
                  placeholder="Buscar por Cliente…" (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()" style="max-width: 1000px;" />
              </th>
              <th class="d-none d-md-table-cell align-top">
                Fecha Emisión<br>
              </th>
              <th class="d-none d-md-table-cell align-top">
                Fecha Vto.<br>
              </th>
              <th class="d-none d-md-table-cell align-top text-right">
                Total<br>
              </th>

              <!-- All -->
              <th class="td-actions text-right p-0">
                <button mat-icon-button type="button" class="btn btn-default btn-link btn-just-icon"
                  [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                  <i class="material-icons">more_vert</i>
                </button>
                <mat-menu #menu="matMenu">

                  <!-- filters -->
                  <!--button mat-menu-item class="d-block d-md-none" (click)="openFilter()">
                            <span>Filtros</span>
                          </button-->
                  <button mat-menu-item (click)="clearFilter()">
                    <span>Limpiar Filtros</span>
                  </button>
                </mat-menu>

              </th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let quote of quotes" [class.text-danger]="quote.isDeleted" class='cursor-pointer'
              (click)="openQuotesModal(quote)">

              <!-- All -->
              <td class="p-0 pl-2" (click)="$event.stopPropagation();">
                <div class="form-check m-0 mx-2">
                  <label class="form-check-label">
                    <input class="form-check-input input-sm" type="checkbox" (click)="toggleSelection(quote._id)"
                      [checked]="selection.all || selection[quote._id]">
                    <span class="form-check-sign">
                      <span class="check"></span>
                    </span>
                  </label>
                </div>
              </td>

              <!-- PC -->
              <td class="d-none d-md-table-cell">{{quote.number ?? ' - ' }}</td>
              <td class="d-none d-md-table-cell p-1">
                <div class="text-center py-1 status-pill text-white"
                  [ngStyle]="{'background-color': quoteStatusColors[quote?.status]}">
                  {{ quoteStatuses[quote?.status] }}
                </div>
              </td>
              <td class="d-none d-md-table-cell bold-item">{{quote.client?.firstname}} {{quote.client?.lastname}}</td>
              <td class="d-none d-md-table-cell">{{quote.date | date:'dd/MM/yyyy':'UTC'}}</td>
              <td class="d-none d-md-table-cell">{{quote.dueDate | date:'dd/MM/yyyy':'UTC'}}</td>


              <!--<td class="d-none d-md-table-cell">
                      <span *ngFor="let p of quote.details">{{p.product.name}} {{p.price}} <br></span>
                    </td>-->
              <td class="d-none d-md-table-cell text-right bold-item">{{quote.total | money: { needSymbol:true } }}</td>

              <!-- Mobile -->
              <td class="d-table-cell d-md-none" style="line-height: 14px;">
                <div class="col-12">
                  <div class="row">
                    <div class="col-8 col-sm-6">
                      <div class="row mb-2 pr-3">
                        <b class="bold-item">
                          N°: {{quote.number ?? ' - ' }}
                        </b>
                      </div>
                      <div class="row mb-2 pr-3">
                        {{quote.client.firstname}} {{quote.client.lastname}}
                      </div>
                      <div class="row mb-2 pr-3">
                        Emisión: {{quote.date | date:'dd/MM/yyyy'}}
                      </div>
                      <div class="row pr-3">
                        Vto: {{quote.dueDate | date:'dd/MM/yyyy'}}
                      </div>
                    </div>
                    <div class="col-4 col-sm-6 d-flex flex-column align-items-center justify-content-center p-0">
                      <div class="row mb-2 bold-item">
                        {{quote.total | money: { needSymbol:true } }}
                      </div>
                      <div class="row">
                        <div class="text-center py-1 status-pill text-white"
                          style="border-radius: 15px; font-weight: 600; padding: 5px 5px; color: white; font-size: 13px;"
                          [ngStyle]="{'background-color': quoteStatusColors[quote?.status]}">
                          {{ quoteStatuses[quote?.status] }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
              <!-- <td class="d-table-cell d-md-none" style="line-height: 14px;">
                <div class="row">
                  <b>{{quote.client.firstname}} {{quote.client.lastname}}</b>
                </div>
                <div class="row">
                  N°: {{quote.number ? quote.number : '' }}
                </div>
                <div class="row">
                  Emisión: {{quote.date | date:'dd/MM/yyyy'}}
                </div>
                <div class="row">
                  Vencimiento: {{quote.dueDate | date:'dd/MM/yyyy'}}
                </div>
                <div class="row">
                  Total: {{quote.total | money: { needSymbol:true } }}
                </div>
                <div class="row">
                  <div class="text-center py-1 status-pill text-white"
                    style="border-radius: 15px; font-weight: 600; padding: 5px 20px; color: white; font-size: 13px;"
                    [ngStyle]="{'background-color': quoteStatusColors.SCHEDULED || quoteStatusColors.DEFAULT}">
                    {{quote?.status || "Presupuestado"}}
                  </div>
                </div>
                <b>{{quote.client.firstname}} {{quote.client.lastname}}</b><br>
                N°: {{quote.number ? quote.number : '' }} <br>
                Emisión: {{quote.date | date:'dd/MM/yyyy'}}<br>
                Vencimiento: {{quote.dueDate | date:'dd/MM/yyyy'}}<br>
                Total: {{quote.total | money: { needSymbol:true } }}
              </td> -->

              <!-- All -->
              <td class="td-actions text-right p-0">
                <button mat-icon-button type="button" class="btn btn-default btn-link btn-just-icon"
                  [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                  <i class="material-icons">more_vert</i>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="openQuotesModal(quote)">
                    <span>Modificar</span>
                  </button>
                  <button mat-menu-item (click)="scheduleTask(quote)"
                    *ngIf="quote?.status != 'SCHEDULED' && !quote.isDeleted">
                    <span>Programar Trabajo</span>
                  </button>
                  <button mat-menu-item (click)="setAcceptedQuote(quote)"
                    *ngIf="quote?.status == 'QUOTED' && !quote.isDeleted">
                    <span>Aceptar presupuesto</span>
                  </button>
                  <button mat-menu-item (click)="openQuote(quote)">
                    <span>Abrir PDF</span>
                  </button>
                  <button mat-menu-item (click)="download(quote)">
                    <span>Descargar</span>
                  </button>
                  <button mat-menu-item (click)="sendEmail(quote)">
                    <span>Enviar por email</span>
                  </button>
                  <button mat-menu-item (click)="openDeleteQuoteConfirm(quote)"
                    *ngIf="quote?.status == 'QUOTED' && !quote.isDeleted">
                    <span>Eliminar</span>
                  </button>
                  <button mat-menu-item (click)="openRestoreQuoteConfirm(quote)" *ngIf="quote.isDeleted">
                    <span>Restaurar</span>
                  </button>
                </mat-menu>
              </td>
            </tr>

            <!-- All  -->
            <tr *ngIf="thereAreMore && !loading">
              <td colspan="10">
                <button class="btn btn-link text-purple-manax text-capitalize p-0" (click)='loadMore()'>+ cargar
                  mas</button>
              </td>
            </tr>

            <tr *ngIf="loading">
              <td colspan="10" class="text-center">
                <div class="d-flex justify-content-center">
                  <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
              </td>
            </tr>

          </tbody>
          <tfoot class="text-purple-manax">
            <tr *ngIf="!loading">
              <td colspan="10" class="text-left p-0 py-2 pl-3">Mostrando: {{ quotes?.length }} presupuestos</td>
            </tr>
          </tfoot>
        </table>
        <!-- </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</div>